import { useEffect, useState, useCallback } from 'react';
import fetchAPI from '../helper/axios';
import { CMS_API_BASE ,IsDevMode} from '../helper/constants';
 
interface InvestFile {
  id: string;
  file_title?: string;
  file_name?: string;
  file_url?: string;
   file_category?: string;
}
 
// Base URL for the API
 const API_BASE = CMS_API_BASE;

const cache = new Map<string, { data: any; timestamp: number }>();
const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes
 
const fetchWithCache = async (key: string, fn: () => Promise<any>) => {
  const now = Date.now();
  const cached = cache.get(key);
  if (cached && now - cached.timestamp < CACHE_DURATION) return cached.data;
  const data = await fn();
  cache.set(key, { data, timestamp: now });
  return data;
};

export const useInvestorData = () => {
  const [image, setImage] = useState<any>(null);
    const [invdata, setInvdata] = useState<any>(null);
  const [files, setFiles] = useState<InvestFile[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [retry, setRetry] = useState(0); // for retry trigger
  const fetchFiles = useCallback(async () => {
    // Fetch investor files with included media
    // For local dev, use a proxy or CORS workaround
    // const response = await fetch('/api/jsonapi/node/investor_file?include=field_investor_file_image');
    let response: Response;
    if (IsDevMode === 1) {
      response = await fetch('/api/jsonapi/node/investor_file?include=field_investor_file_image');
    } else {
      response = await fetch(API_BASE + '/jsonapi/node/investor_file?include=field_investor_file_image');
    }
    
    if (!response.ok) throw new Error(`HTTP error ${response.status}`);
    const { data, included } = await response.json();

    const getFile = (mediaId: string) => included?.find((i: any) => i.type === 'file--file' && i.id === mediaId);

    const formatted: InvestFile[] = data.map((item: any) => {
      const mediaId = item.relationships.field_investor_file_image?.data?.id;
      const file = getFile(mediaId);
      return {
        id: item.attributes.drupal_internal__nid,
        file_title: item.attributes.field_file_title,
        status: item.attributes.status,
        file_category: item.attributes.field_investor_category,
        file_url: file?.attributes?.uri?.url || null,
        file_name: file?.attributes?.filename || null,
      };
    });
    return formatted;
  }, []);

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);
        const [heroImg,data, docs] = await Promise.all([
          fetchWithCache('investor-hero', () => fetchAPI('media/74/edit')),
          fetchWithCache('investor-data', () => fetchAPI('node/70')),
          fetchWithCache('investor-files', fetchFiles),
        ]);
        setImage(heroImg);
        setInvdata(data);
        setFiles(docs);
      } catch (e: any) {
        setError(e.message || 'Failed to load investor data');
          // Retry after 3 seconds
        setTimeout(() => setRetry((prev) => prev + 1), 10000);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [fetchFiles,retry]);

  return { image, invdata, files, loading, error };
};

export type { InvestFile };


